import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import CloseIcon from '@mui/icons-material/Close';
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, CircularProgress, IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { max_quantity_used } from "../../../Utils"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"

export default function ContractItemEditQuantityModal({
    rentalContractItem,
    rentalItem,
    open,
    closeModal
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [quantity, setQuantity] = React.useState(rentalContractItem.quantity)
    const [contractItems, setContractItems] = React.useState([])
    const [contractSavingStep, setContractSavingStep] = React.useState(0)
    const [isLoading, setIsLoading] = React.useState(false)

    const getContracts = () => {
        setIsLoading(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get("rentalcontractitems", {
                params: {
                    filters: JSON.stringify({
                        and: [
                            { 'estimated_start_date.lt': rentalContractItem.estimated_end_date },
                            { 'estimated_end_date.gt': rentalContractItem.estimated_start_date },
                            { 'rental_item_id.eq': rentalItem.id },
                        ]
                    })
                },
            }).then((rental_contract_items) => {
                console.log(rental_contract_items)
                setContractItems(rental_contract_items.data.data.filter((r) => r.id !== rentalContractItem.id && ["RESERVED", "CHECKED_OUT"].includes(r.status)))
                setIsLoading(false)
            })
        )
    }

    const save = (event) => {
        setContractSavingStep(1)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`rentalcontractitems/${rentalContractItem.id}`, { quantity: quantity }).then((response_rentalContractItem) => {
                console.log(response_rentalContractItem)
                enqueueSnackbar('Successfully updated quantity', { variant: 'success' })
                setContractSavingStep(0)
                closeModal(true)
            }))
    }

    React.useEffect(() => {
        if (open === true) {
            getContracts()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const max_used = max_quantity_used(contractItems)
    const max_available = rentalItem?.total_quantity - max_used

    return (
        (<Box>
            <LoadingBackdropIndeterminate
                open={contractSavingStep > 0}
                text={"Saving Order"}
            />
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    {"Modifying Quantity"}
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {isLoading &&
                        < Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress />
                        </Box>
                    }
                    <TextField
                        autoFocus
                        margin="dense"
                        id="quantity"
                        label={`Quantity (Max Available #${max_available})`}
                        type="number"
                        fullWidth
                        variant="standard"
                        value={quantity}
                        onChange={(event) => setQuantity(Math.min(Math.max(parseInt(event.target.value), 1), rentalItem.total_quantity))}
                        error={quantity > max_available}
                        helperText={quantity > max_available ? "Quantity not available" : ""}
                        // InputProps={{
                        //     startAdornment: (
                        //         <InputAdornment position="start">
                        //             {<AttachMoneyIcon />}
                        //         </InputAdornment>
                        //     ),
                        // }}
                        sx={{ minWidth: '125px' }}
                        disabled={isLoading}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Box>)
    );
}
